/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProjectSettingsCannedResponsesEntrypointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const projectSettingsCannedResponsesEntrypoint: EntryPoint<
	ProjectSettingsCannedResponsesEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<ProjectSettingsCannedResponsesEntrypointComponent>(
		/* webpackChunkName: "async-customer-service-project-settings-canned-responses" */ './ProjectSettingsCannedResponsesApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
